import InventoryList from "../components/inventory/InventoryList";
import HistoryForm from "../components/inventory/HistoryForm";
import TemplatePage from "../pages/TemplatePage";
import MaterialsPage from "../pages/MaterialsPage";

export const TABS = [
    { label: "Inventory", endpoint: "inventory", component: InventoryList },
    { label: "Materials", endpoint: "materials", component: MaterialsPage },
    { label: "History", endpoint: "history", component: HistoryForm },
    { label: "Template", endpoint: "templates", component: TemplatePage },
];